// L5 (923-core-context context/engineering/spark-rewards/phase-51-leaderboard-to-design.md): the frame's per-row value chips read "Stay a Student /
// Helping Others / Accountability / Raise the Bar / Keep Trying", while the canonical titles
// (923-core-spark-rewards-epic-start.md, pavel-confirmed) are "Stay a Student", "Prioritize Helping
// Others", "Accountability is Key", "Raise the Bar", "Keep Trying. Get it Done". Three of five are
// shortened, and there is NO single derivation rule that produces all three -- drop-first-word breaks
// "Stay a Student" (nothing to drop), first-word-only breaks "Raise the Bar" ("Raise" alone reads as
// unfinished), and truncate-at-period breaks "Accountability is Key" (no period at all). So this is a
// map keyed on the title, exactly the pattern `ZERO_SPARKS_LABEL_BY_VALUE_TITLE`
// (MySparks/ladderFillPercent.ts) already uses, and for the same reasons: `core_value_id` differs
// between environments (an id-keyed map would silently mislabel in QA/production), and titles HAVE been
// renamed before, so a title match can miss -- but here that's fine, because this is cosmetic copy and
// falling back to the FULL title (not a generic placeholder) is the correct degrade: the full title is
// always a truthful, if longer, label for the same value.
const SHORT_LABEL_BY_VALUE_TITLE: Record<string, string> = {
  "stay a student": "Stay a Student",
  "prioritize helping others": "Helping Others",
  "accountability is key": "Accountability",
  "raise the bar": "Raise the Bar",
  "keep trying. get it done": "Keep Trying",
};

/**
 * The per-row value chip's short label for a core value's title -- matched case-insensitively and
 * trimmed, falling back to the FULL title verbatim on a miss (see the module comment above for why
 * degrading beats throwing here).
 *
 * @param title - the core value's own title (e.g. `LeaderboardEntry`'s resolved top core value).
 * @returns the mapped short label, or `title` itself when it has none.
 */
export const leaderboardValueChipLabel = (title: string): string => {
  const key = title.trim().toLowerCase();
  return SHORT_LABEL_BY_VALUE_TITLE[key] ?? title;
};
